import axiosInstance from "../../interceptor/intercetptor-inctence";



// Get All Stocks
export const getStocksAPI = (data) => {
	return axiosInstance.post(`pharma/get-stocks-on-name`, data);
}

export const getExpiredStocks = (data) => {
	return axiosInstance.post(`pharma/get-stocks-on-name`, data);
}

export const getMinStockAlert = (data) => {
	return axiosInstance.post(`pharma/min-stock-alert`, data);
}

export const getNearToExpireStocks = (data) => {
	return axiosInstance.post(`pharma/near-to-expire`, data);
}